import { FC, useEffect, useState } from 'react';
import { Typography, Grid, IconButton, Tooltip } from '@mui/material';
import { useAppDispatch } from '../../../hooks';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { fetchLedgerSummaryPdf, fetchLedgerSummaryExcel } from './Services';
import { showAlertAction } from '../../../store/alerts';
import { getLedgerSummaryDataAction } from './actions';
export const circleButtonSize = '32px'
export const circleIconSize = '18px'

type LedgerSummaryHeaderProps = {
  partyId?: string
}

const LedgerSummaryHeader: FC<LedgerSummaryHeaderProps> = ({ partyId }) => {

  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [isEnabled, setIsEnabled] = useState(true);

  const dispatchAction = useAppDispatch();
  const fetchPDF = (() => {
    setIsEnabled(false)
    fetchLedgerSummaryPdf(partyId).then(
      (response) => {
        setIsEnabled(true)
        if (response.success) {
          window.open(response.data, '_blank')
        } else {
          dispatchAction(
            showAlertAction({
              message: response.message,
              severity: 'error',
            })
          )
        }

      }
    )

  })

  const fetchExcel = (() => {
    setIsEnabled(false)
    fetchLedgerSummaryExcel(partyId).then(
      (response) => {
        setIsEnabled(true)
        if (response.success) {
          window.open(response.data, '_blank')
        } else {
          dispatchAction(
            showAlertAction({
              message: response.message,
              severity: 'error',
            })
          )
        }

      }
    )

  })
  useEffect(() => {
    if (isInitialLoad) {
      dispatchAction(getLedgerSummaryDataAction(partyId));
      setIsInitialLoad(false);
    }
  }, [isInitialLoad, partyId, dispatchAction]);

  return (
    <>
      <Grid container alignItems="stretch">
        <Grid item md={5}>
          <Typography variant="h3" component="h3">
          Party-Wise Ledger
          </Typography>
        
        </Grid>
      
        <Grid
          md={7}
          item
          sx={{ width: 250, textAlign: 'right', display: 'flex', justifyContent: 'right', alignItems: 'center' }}
        >
          <Tooltip title="Export Excel">
            <IconButton
              disabled={!isEnabled}
              onClick={() => {
                fetchExcel();
              }}
              sx={{
               ml: 3,
               mr: 1.25,
                backgroundColor: '#1976d2',
                '&:hover': {
                  backgroundColor: '#1565c0',
                },
                color: 'white',
                width: circleButtonSize,
                height: circleButtonSize,
                minWidth: circleButtonSize,
                minHeight: circleButtonSize,
                maxWidth: circleButtonSize,
                maxHeight: circleButtonSize,
                borderRadius: '50%',
                padding: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Typography sx={{ fontSize: circleIconSize, fontWeight: 'bold', lineHeight: 1 }}>xl</Typography>
            </IconButton>
          </Tooltip>
          <Tooltip title="Export PDF">
            <IconButton
              disabled={!isEnabled}
              onClick={() => {
                fetchPDF();
              }}
              sx={{
               mr: 2,
                backgroundColor: '#1976d2',
                '&:hover': {
                  backgroundColor: '#1565c0',
                },
                color: 'white',
                width: circleButtonSize,
                height: circleButtonSize,
                minWidth: circleButtonSize,
                minHeight: circleButtonSize,
                maxWidth: circleButtonSize,
                maxHeight: circleButtonSize,
                borderRadius: '50%',
                padding: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <PictureAsPdfIcon sx={{width:circleIconSize, height:circleIconSize}}/>
            </IconButton>
          </Tooltip>
         
        </Grid>
      </Grid>
    </>
  );
};

export default LedgerSummaryHeader;
